<!-- =========================================================================================
  File Name: CompanyEditGeneralDetails.vue
  Description: Entity Edit account content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-external-links-form">
    <vs-row>
      <vs-col :class="readonly ? 'readonly-form' : ''">
        <card-page card-title="External Links">
          <additive-widget
              ref="formExternalLinks"
              v-model="model"
              :form-options="formOptions"
              :schema="schemaLinks"
              label="external links"
          />
        </card-page>
        <card-page card-title="Business Parameters">
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
              v-if="schema"
              ref="form"
              :model="model"
              :options="formOptions"
              :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from "@/components/mixins/FormModelMixin";
import CardPage from '../../../components/Views/CardPage';
import AdditiveWidget from '../../../../components/form/fields/AdditiveWidget';
import { selectOptions, arrayOptions } from '@/components/form/FormElementOption';

export default {
  components: {
    CardPage,
    AdditiveWidget,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [FormModelMixin],
  data() {
    return {
      additiveForms: [
        'formExternalLinks',
      ],
      rawWebserviceParametersOptions: [],
      webservices: [],
      model: {
        external_links: [],
        webservice_parameters: [],
        webServices: [],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      schema: null,
      schemaLinks: {
        groups: [
          {
            styleClasses: "w-full",
            fields: [
              {
                model: 'external_links',
                ...arrayOptions,
                hideAddButton: this.readonly,
                showRemoveButton: !this.readonly,
                items: {
                  type: 'object',
                  styleClasses: 'w-full',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-full',
                        fields: [
                          {
                            disabled: () => this.readonly,
                            type: "vueMultiSelect",
                            styleClasses: "w-1/3",
                            label: "Link Type",
                            model: "LinkType_FK",
                            values: () => this.linkTypesOptions,
                            selectOptions,
                            required: () => !this.readonly,
                            validator: ['required'],
                          },
                          {
                            disabled: () => this.readonly,
                            type: "input",
                            inputType: "text",
                            styleClasses: "w-1/3",
                            label: "Link",
                            model: "ExternalLink",
                            required: () => !this.readonly,
                            validator: [
                              'required',
                              'checkEmptyInput'
                            ]
                          },
                        ]
                      }
                    ]
                  }
                }
              }
            ]
          }
        ]
      },

      linkTypesOptions: [],
      options: [
        {
          endpoint: () => this.$api.companyExternalLink.getOptions(),
          optionsFieldName: "linkTypesOptions",
          nameFieldName: "Type",
          idFieldName: 'LinkType_FK',
          modelArrayName: 'external_links',
        },
      ],
    }
  },
  async created() {
    await this.getRelatedData();
  },
  methods: {
    async getRelatedData() {
      await this.getWebserviceParameters();
      this.mapLocalData();
    },
    async getWebserviceParameters() {
      try {
        const {data} = await this.$api.externalWebservices.all();
        this.rawWebserviceParametersOptions = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of external webservice parameters. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    mapLocalData() {
      let services = [];
      const schema = {
        groups: [],
      };

      this.rawWebserviceParametersOptions.forEach((service) => {
        let fields = [];

        service.parameters.forEach((parameter) => {
          let companyParam = this.value.webservice_parameters.find((item) =>
              parseInt(item.WebserviceParameter_FK) === parameter.WebserviceParameter_PK
          );

          if (companyParam && companyParam.ParamterValue) {
            this.model.webServices[parameter.WebserviceParameter_PK] = {
              WebserviceParameter_FK: parameter.WebserviceParameter_PK,
              ParamterValue: companyParam.ParamterValue,
              CompanyWebserviceParameter_PK: (companyParam) ? companyParam.CompanyWebserviceParameter_PK : null,
            };
          }

          fields.push({
            disabled: () => this.readonly,
            type: "input",
            inputType: "text",
            styleClasses: "w-1/3",
            label: parameter.ParameterName,
            model: `webServices.${parameter.WebserviceParameter_PK}.ParamterValue`,
            onChanged: async (model, newValue) => {
              if (!newValue) {
                return delete model.webServices[parameter.WebserviceParameter_PK];
              }

              model.webServices[parameter.WebserviceParameter_PK] = {
                WebserviceParameter_FK: parameter.WebserviceParameter_PK,
                ParamterValue: newValue,
                CompanyWebserviceParameter_PK: (companyParam) ? companyParam.CompanyWebserviceParameter_PK : null,
              };
            },
          });
        })

        schema.groups.push({
          legend: service.ServiceName,
          styleClasses: "w-full",
          fields
        });
      });

      this.schema = schema;
      this.webservices = services;
    },
  },
}
</script>

<style lang="scss">
.vue-form-generator {
  .external-links-label {
    margin: 0;

    span {
      margin: 0;
      font-size: 15.96px;
      font-family: inherit;
      font-weight: 500;
      line-height: 1.2;
      color: #2c2c2c;
    }
  }
}
</style>
